import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (payload) => api.post("/leads", payload).then(r => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then(r => r.data);

const authHeaders = (token) => ({ headers: { "X-Admin-Token": token } });

export const fetchLeads = (token) => api.get("/admin/leads", authHeaders(token)).then(r => r.data);
export const fetchStats = (token) => api.get("/admin/stats", authHeaders(token)).then(r => r.data);
export const updateLeadStatus = (token, id, status) =>
  api.patch(`/admin/leads/${id}`, { status }, authHeaders(token)).then(r => r.data);
export const deleteLead = (token, id) =>
  api.delete(`/admin/leads/${id}`, authHeaders(token)).then(r => r.data);
